<!-- Header Section -->
<div class="container-fluid mt-3">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <div>
      <h4 class="display-6 mb-1 font-weight-bold text-primary"><i class="fas fa-shipping-fast"></i> Taxas de Entregas</h4>
      <p class="text-muted mb-0">Gerenciamento de taxas calculadas para entregas</p>
    </div>
    <div>
      <button type="button" class="btn btn-primary rounded-pill px-4" (click)="carregueTaxas()">
        <i class="fas fa-sync-alt mr-2"></i> Atualizar
      </button>
    </div>
  </div>

  <!-- Filters and Search - Layout Reorganizado -->
  <div class="card mb-4 border-0 bg-light filtro-card">
    <div class="card-body py-3">
      <!-- Primeira Linha: Busca e Tipos de Entrega -->
      <div class="row align-items-center mb-3">
        <!-- Busca por endereço -->
        <div class="col-lg-7 col-md-6 mb-2 mb-md-0">
          <div class="input-group">
            <span class="input-group-text bg-white border-right-0"><i class="fas fa-search text-muted"></i></span>
            <input type="text" class="form-control border-left-0" placeholder="Buscar por endereço..." [(ngModel)]="termoBusca" (keyup.enter)="aplicarBusca()" name="busca">
            <div class="input-group-append">
              <button class="btn btn-primary" type="button" (click)="aplicarBusca()">
                <i class="fas fa-search"></i> Buscar
              </button>
            </div>
          </div>
        </div>

        <!-- Tipos de entrega -->
        <div class="col-lg-5 col-md-6">
          <div class="d-flex justify-content-md-end">
            <div class="btn-group" role="group">
              <button type="button" class="btn btn-outline-success"
                      [ngClass]="{'active': filtroAtual === 'entregas'}"
                      (click)="aplicarFiltro('entregas')">
                <i class="fas fa-check-circle mr-1"></i> Entregas
              </button>
              <button type="button" class="btn btn-outline-danger"
                      [ngClass]="{'active': filtroAtual === 'fora-area'}"
                      (click)="aplicarFiltro('fora-area')">
                <i class="fas fa-ban mr-1"></i> Fora da Área
              </button>
              <button type="button" class="btn btn-outline-secondary"
                      [ngClass]="{'active': filtroAtual === 'todos'}"
                      (click)="aplicarFiltro('todos')">
                <i class="fas fa-filter mr-1"></i> Todos
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Segunda Linha: Filtro de Datas -->
      <div class="row">
        <div class="col-12">
          <div class="d-flex align-items-center filtro-datas">
            <kendo-daterange class="d-flex align-items-center">
              <div class="d-flex align-items-center filtro-inputs">
                <div class="input-wrapper mr-2">
                  <label class="input-label mb-0 mr-1">De</label>
                  <kendo-dateinput kendoDateRangeStartInput [(value)]="filtroDatas.inicio" class="filtro-date-input"></kendo-dateinput>
                </div>
                <div class="input-wrapper">
                  <label class="input-label mb-0 mr-1">Até</label>
                  <kendo-dateinput kendoDateRangeEndInput [(value)]="filtroDatas.fim" class="filtro-date-input"></kendo-dateinput>
                </div>
              </div>
              <button class="btn btn-primary ml-2" type="button" (click)="aplicarBusca()">
                <i class="fas fa-filter mr-1"></i> Filtrar
              </button>
            </kendo-daterange>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading Indicator -->
  <div class="d-flex justify-content-center my-5" *ngIf="carregando">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Carregando...</span>
    </div>
  </div>

  <!-- Cards View of Delivery Rates -->
  <div class="row" *ngIf="!carregando && view && view.data">
    <div class="col-xl-3 col-lg-4 col-md-6 mb-3" *ngFor="let item of view.data; let i = index">
      <div class="card h-100 border-0 shadow position-relative">
        <!-- Status Banner com mais destaque e padding -->
        <div class="card-status-banner w-100 py-2 text-center text-white text-uppercase font-weight-600"
             [ngClass]="{'bg-success': item.fazEntrega, 'bg-danger': !item.fazEntrega}"
             style="font-size: 1rem; border-radius: 4px 4px 0 0; letter-spacing: 0.5px;">
          <i class="fas mr-2" [ngClass]="{'fa-check-circle': item.fazEntrega, 'fa-exclamation-circle': !item.fazEntrega}" style="font-size: 1.1rem;"></i>
          {{ item.fazEntrega ? 'Entrega' : 'Fora da Área' }}
        </div>

        <div class="card-body p-2 mb-4">
          <!-- Endereço com título destacado -->
          <div class="address-section mb-1">
            <div class="d-flex align-items-center justify-content-between border-bottom pb-2 mb-2">
              <span class="text-primary font-weight-bold d-flex align-items-center" style="font-size: 0.9rem;">
                <i class="fas fa-map-marker-alt text-primary mr-2" style="font-size: 1.1rem;"></i>
                Endereço
              </span>
              <span class="font-weight-bold border-left pl-2" style="font-size: 0.8rem;">
                <i class="far fa-calendar-alt mr-1"></i>{{item.horario | date: 'dd/MM'}}
                <i class="far fa-clock ml-1 mr-1"></i>{{item.horario | date: 'HH:mm'}}
              </span>
            </div>
            <div class="bg-light rounded p-1">
              <p class="mb-0 font-weight-bold" style="font-size: 0.9rem; line-height: 1.2;" [innerHTML]="item.endereco ? (item.endereco | highlight:termoBusca) : 'Endereço não disponível'">
              </p>
              <div class="border-top pt-1 mt-1">
                <small class="d-block" style="font-size: 0.7rem;" [ngClass]="{'text-success': !item.erro && item.fazEntrega, 'text-danger': !item.erro && !item.fazEntrega, 'text-muted': item.erro}">
                  <i class="fas" [ngClass]="{'fa-check-circle': !item.erro && item.fazEntrega, 'fa-times-circle': !item.erro && !item.fazEntrega, 'fa-info-circle': item.erro}"></i>
                  {{item.erro || (item.fazEntrega ? 'Entrega disponível' : 'Fora da área de entrega')}}
                </small>
              </div>
            </div>
          </div>

          <!-- Grid de informações mais compacto -->
          <div class="row g-1">
            <!-- Valor -->
            <div class="col-6">
              <div class="valor-container">
                <div class="d-flex align-items-center">
                  <div class="icon-circle d-flex align-items-center justify-content-center rounded-circle mr-2"
                       [ngClass]="{'bg-success': item.fazEntrega, 'bg-danger': !item.fazEntrega}">
                    <i class="fas fa-coins text-white"></i>
                  </div>
                  <div>
                    <small class="d-block text-muted">Valor</small>
                    <strong class="d-block" [ngClass]="{'text-success': item.fazEntrega, 'text-danger': !item.fazEntrega}">
                      {{ item.fazEntrega ? (item.valor | currency: 'BRL') : '-' }}
                    </strong>
                  </div>
                </div>
              </div>
            </div>

            <!-- Distância -->
            <div class="col-6">
              <div class="distancia-container">
                <div class="d-flex align-items-center">
                  <div class="icon-circle d-flex align-items-center justify-content-center rounded-circle mr-2">
                    <i class="fas fa-route text-white"></i>
                  </div>
                  <div>
                    <small class="d-block text-muted">Distância</small>
                    <strong class="d-block">
                      {{ item.distancia ? (item.distancia | number: '1.2-2') + ' KM' : '-' }}
                    </strong>
                  </div>
                </div>
              </div>
            </div>

            <!-- Cobrança e Cálculo em linha -->
            <div class="col-12 mt-1">
              <div class="d-flex justify-content-between bg-light rounded p-1">
                <div class="d-flex align-items-center">
                  <i class="fas fa-money-bill-wave text-warning mr-1" style="font-size: 0.7rem;"></i>
                  <small class="text-muted" style="font-size: 0.7rem;">{{ item.tipoDeCobranca || '-' }}</small>
                </div>
                <div class="d-flex align-items-center">
                  <i class="fab fa-google text-primary" *ngIf="item.calculadoPor === 'google'" style="font-size: 0.7rem;"></i>
                  <i class="fas fa-location-arrow" *ngIf="item.calculadoPor === 'tomtom'" style="font-size: 0.7rem;"></i>
                  <i class="fas fa-gift text-success" *ngIf="item.calculadoPor === 'frete-gratis-valor'" style="font-size: 0.7rem;"></i>
                  <i class="fas fa-store text-info" *ngIf="item.calculadoPor === 'retirada'" style="font-size: 0.7rem;"></i>
                  <i class="fas fa-exclamation text-danger" *ngIf="item.calculadoPor === 'erro'" style="font-size: 0.7rem;"></i>
                  <i class="fas fa-times text-danger" *ngIf="item.calculadoPor === 'nao-entrega'" style="font-size: 0.7rem;"></i>
                  <i class="fas fa-question text-secondary" *ngIf="!item.calculadoPor" style="font-size: 0.7rem;"></i>
                  <small class="ml-1 text-muted" style="font-size: 0.7rem;">{{ item.calculadoPor || '-' }}</small>
                </div>
              </div>
            </div>
          </div>

          <!-- Botões de ação fixos no final -->
          <div class="d-flex justify-content-center position-absolute w-100" style="bottom: 8px; left: 0; margin-bottom: 6px;">
            <a class="btn btn-sm btn-outline-primary rounded-pill px-3 py-1 mr-2"
               [href]="item.linkMapa"
               target="_blank"
               *ngIf="item.localizacao"
               style="font-size: 0.9rem;">
              <i class="fas fa-route mr-1"></i><span class="ml-1">Rota</span>
            </a>
            <button class="btn btn-sm btn-outline-info rounded-pill px-3 py-1"
                    (click)="exibaMapa(item)"
                    *ngIf="item.localizacao"
                    style="font-size: 0.9rem;">
              <i class="fas fa-map-marked-alt mr-1"></i><span class="ml-1">Mapa</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Mensagem quando não há resultados -->
  <div class="empty-results-container py-5 my-4" *ngIf="!carregando && view && view.data && view.data.length === 0">
    <div class="d-flex flex-column align-items-center justify-content-center">
      <div class="empty-icon-container mb-4">
        <div class="position-relative">
          <!-- Círculo principal com gradiente -->
          <div class="empty-icon-circle d-flex align-items-center justify-content-center rounded-circle shadow"
               style="width: 180px; height: 180px; background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%); border: 8px solid rgba(255,255,255,0.8);">

            <!-- Círculo de fundo para o mapa -->
            <div class="position-absolute" style="width: 120px; height: 120px; background-color: rgba(230, 244, 255, 0.7); border-radius: 50%; z-index: 1;"></div>

            <!-- Ícone de mapa no fundo -->
            <i class="fas fa-map text-info position-absolute" style="font-size: 3.5rem; opacity: 0.2; z-index: 2; transform: rotate(-15deg);"></i>

            <!-- Ícone de localização principal -->
            <div class="position-relative" style="z-index: 3;">
              <i class="fas fa-map-marker-alt text-danger" style="font-size: 4.5rem; filter: drop-shadow(0 4px 6px rgba(0,0,0,0.1));"></i>

              <!-- Símbolo de pesquisa com círculo -->
              <div class="position-absolute bg-white rounded-circle d-flex align-items-center justify-content-center"
                   style="width: 50px; height: 50px; bottom: -5px; right: -15px; border: 3px solid #f8f9fa; box-shadow: 0 4px 8px rgba(0,0,0,0.1);">
                <i class="fas fa-search text-primary" style="font-size: 1.5rem;"></i>
              </div>

              <!-- Linha diagonal -->
              <div class="position-absolute bg-danger"
                   style="width: 75px; height: 4px; transform: rotate(45deg); top: 55px; left: -10px; border-radius: 4px;"></div>
            </div>
          </div>

          <!-- Pequenos elementos decorativos -->
          <div class="position-absolute bg-warning rounded-circle"
               style="width: 25px; height: 25px; top: 15px; right: -5px; opacity: 0.7; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
            <i class="fas fa-exclamation text-white position-absolute" style="font-size: 0.8rem; top: 6px; left: 11px;"></i>
          </div>
        </div>
      </div>
      <div class="text-center mb-4">
        <h4 class="font-weight-bold text-dark mb-3">Nenhuma taxa de entrega encontrada</h4>
        <p class="text-muted mb-4" style="max-width: 500px;">
          Não encontramos nenhuma taxa de entrega para os filtros aplicados. Tente alterar os critérios de busca ou verificar o endereço digitado.
        </p>
      </div>
    </div>
  </div>

  <!-- Paginação com botão Carregar Mais -->
  <div class="d-flex flex-column align-items-center mt-4 mb-3">
    <div class="text-muted mb-3">
      Mostrando {{ view?.data?.length || 0 }} de {{ view?.total || 0 }} registros
    </div>
    <div *ngIf="view?.data?.length < view?.total" class="col-md-4 text-center">
      <button class="btn btn-primary btn-block py-2" (click)="carregarMais()" [disabled]="carregandoMais">
        <span *ngIf="!carregandoMais"><i class="fas fa-plus-circle mr-2"></i> Carregar Mais</span>
        <span *ngIf="carregandoMais">
          <i class="fas fa-spinner fa-spin mr-2"></i> Carregando...
          </span>
      </button>
    </div>
  </div>
</div>

<!-- Map Dialog -->
<kendo-dialog title="Localização no Mapa" *ngIf="exibindoMapa" (close)="fecharTelaMapa()"
             [minHeight]="altura" [height]="altura" [width]="800" class="map-dialog">
  <div style="margin: -16px;">
    <app-tela-areas-de-entrega [exibirFormKML]="false" [localizacao]="taxaSelecionada"
                               [componente]="true"></app-tela-areas-de-entrega>
  </div>
</kendo-dialog>
